export default {"src":"/_next/static/media/JPFlag.e6f0e2bf.svg","height":600,"width":900};